import Link from "next/link";
import { Heading, Text, Stack } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { FOOTER_CONSTANTS, SUPPORT_OPTIONS } from "../footer.constants";

const FooterSupport = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>{FOOTER_CONSTANTS.SUPPORT}</Heading>
      <Stack>
        {SUPPORT_OPTIONS.map((option) => {
          const { name, path } = option;
          return (
            <Link href={path} key={path}>
              <Text _hover={{ textDecor: "underline" }}>{name}</Text>
            </Link>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default FooterSupport;
